import { fmtUsd } from "@/lib/api";
import { cn } from "@/lib/utils";
import { X, Plus } from "lucide-react";

export const PriceTicker = ({ prices, selected, onSelect, onAdd, onRemove }) => {
  return (
    <div data-testid="price-ticker" className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3">
      {prices.map((p) => {
        const up = (p.change24h ?? 0) >= 0;
        const isSel = selected === p.symbol;
        return (
          <div
            key={p.symbol}
            data-testid={`ticker-${p.symbol}`}
            onClick={() => onSelect(p.symbol)}
            className={cn(
              "group relative text-left rounded-lg border bg-[var(--surface)] p-4 transition-all duration-200 hover:bg-[var(--surface-hover)] cursor-pointer",
              isSel ? "border-[#00FFA3]/60 ring-1 ring-[#00FFA3]/30" : "border-[var(--border)]"
            )}
          >
            {onRemove && (
              <button
                data-testid={`remove-ticker-${p.symbol}`}
                onClick={(e) => { e.stopPropagation(); onRemove(p.symbol); }}
                className="absolute top-2 right-2 h-5 w-5 rounded flex items-center justify-center text-[var(--text-faint)] opacity-0 group-hover:opacity-100 hover:bg-[#FF3366]/15 hover:text-[var(--neg)] transition-all"
              >
                <X className="h-3 w-3" />
              </button>
            )}
            <div className="flex items-center gap-2 mb-2">
              {p.image && <img src={p.image} alt={p.symbol} className="h-5 w-5 rounded-full" />}
              <span className="font-head font-bold text-sm">{p.symbol}</span>
            </div>
            <div className="font-mono text-lg font-bold tracking-tight">{fmtUsd(p.price)}</div>
            <div className={cn("font-mono text-xs mt-0.5", up ? "text-[var(--pos)]" : "text-[var(--neg)]")}>
              {up ? "▲" : "▼"} {Math.abs(p.change24h ?? 0).toFixed(2)}%
            </div>
          </div>
        );
      })}
      {onAdd && (
        <button
          data-testid="add-coin-btn"
          onClick={onAdd}
          className="rounded-lg border border-dashed border-[var(--border)] bg-transparent p-4 flex flex-col items-center justify-center gap-1.5 text-[var(--text-faint)] hover:border-[#00FFA3]/40 hover:text-[var(--pos)] hover:bg-[#00FFA3]/5 transition-all min-h-[92px]"
        >
          <Plus className="h-5 w-5" />
          <span className="text-xs">Coin Ekle</span>
        </button>
      )}
    </div>
  );
};
